import { render, staticRenderFns } from "./DialogEditProduct.pug?vue&type=template&id=27e09d68&lang=pug&"
import script from "./DialogEditProduct.vue?vue&type=script&lang=js&"
export * from "./DialogEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports